// @flow

import type {ReduxActionType} from "../../flow/ReduxActionType";

/**
 * Load AI translation models
 * @type: Action
 */
export const aiModelsLoad = (): ReduxActionType => ({
    type: 'AI_MODELS_LOAD',
    payload: null,
});

/**
 * AI translation models loaded
 * @type: Event
 */
export const aiModelsLoaded = (models: []): ReduxActionType => ({
    type: 'AI_MODELS_LOADED',
    payload: models,
});

/**
 * AI translation models request failed
 * @type: Event
 */
export const aiModelsRequestFailed = (): ReduxActionType => ({
    type: 'AI_MODELS_REQUEST_FAILED',
    payload: null,
});
